import { useSelector } from 'react-redux'

import { SETTINGS_IMPORT_SECTION_DATA } from '@webapp/containers/SettingsImport/constants'
import { makeSelectFeatureSwitches } from '@webapp/core/stores/global'
import { useProcurifyIntl } from '@webapp/hooks'
import { LegacyImporter } from '@webapp/platform/_unmigrated/Importer'
import messages from './messages'

export interface BudgetCategoryImporterProps {
  handleModalClose: () => void
}

export const BudgetCategoryImporter = ({
  handleModalClose,
}: BudgetCategoryImporterProps) => {
  const intl = useProcurifyIntl()
  const { enable_flexible_spend_tracking: isFlexibleSpendTrackingEnabled } =
    useSelector(makeSelectFeatureSwitches())

  return (
    <LegacyImporter
      title={intl.formatMessage(
        isFlexibleSpendTrackingEnabled
          ? messages.importerTitle
          : messages.oldImporterTitle
      )}
      type={SETTINGS_IMPORT_SECTION_DATA.BUDGET_CATEGORY.type}
      onDismiss={handleModalClose}
      {...SETTINGS_IMPORT_SECTION_DATA.BUDGET_CATEGORY.importerOptions}
    />
  )
}
